<template>
  <div class="alipay">
    <h2>{{message}}</h2>
    <router-link to="/" v-if="status">回到首页</router-link>
  </div>
</template>

<script>
import { checkPayStatus } from "@/assets/js/axios.js";
export default {
  name: "alipay",
  data() {
    return {
      timer: "",
      message: "支付中请稍后...",
      status: false
    };
  },
  created() {
    this.timer = setInterval(() => {
      checkPayStatus().then(data => {
        if(data.code == 1){
          if (data.data.finish == 1) {
            if(data.data.type==0){
              this.message = "注册成功，请返回首页点击右上角登录按钮登录并完成后续操作";
            }else{
              this.message = "充值成功，请返回首页完成后续操作";
            }
            clearInterval(this.timer);
            this.status = true
          }
        }else{
          this.message = data.msg || "付款出现问题或注册出现问题，需重新注册，付款已退款";
          clearInterval(this.timer);
          this.status = true
        }
      });
    }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style scoped lang="less">
.alipay {
  height: 250px;
  width: 1200px;
  margin: 0 auto 60px;
  text-align: center;
  background: #fff;
  padding-top: 100px;
  h2 {
    color: red;
  }
  a {
    color: #109eff;
    line-height: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alipay.vue